
import Clarity from "@microsoft/clarity";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from "../../project_config";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import Footer from "../common/footer/Footer";
import { FooterButton } from "../common/footer/FooterButton";
import Header from "../common/header/Header";
import CatalogExpertiseFilterSection from "../common/expertise/CatalogExpertiseFilterSection";
import ClipSection from "./clip/ClipSection";
import SearchSection from "./search/SearchSection";

function clipListPath(query, expertiseId) {
	const params = new URLSearchParams();
	if (query) {
		params.set("query", query);
	}
	if (expertiseId) {
		params.set("expertise_id", expertiseId);
	}
	const qs = params.toString();
	return qs ? `/video_clips/?${qs}` : "/video_clips/";
}

export default function VideoClipList() {
	Clarity.init(CLARITY_PROJECT_ID);
	const navigate = useNavigate();
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const [searchParams] = useSearchParams();
	const queryParam = searchParams.get("query");
	const expertiseIdParam = searchParams.get("expertise_id");

	const linkDataList = [
		{ label: "خانه", href: "/" },
		{ label: "کلیپ", href: "/video_clips/" },
	];

	function onExpertiseClick(newExpertiseId) {
		if (String(newExpertiseId) !== String(expertiseIdParam)) {
			navigate(clipListPath(queryParam, newExpertiseId || ""));
		} else {
			navigate(clipListPath(queryParam, ""));
		}
	}

	function onSearch(newQuery) {
		if (newQuery === queryParam) {
			return;
		}
		navigate(clipListPath(newQuery || "", expertiseIdParam || ""));
	}

	return (
		<>
			<Helmet>
				<title>کلیپ | همراهتیم</title>
				<meta name="description" content="کلیپ‌های آموزشی همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen flex flex-col justify-between">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? "w-[1200px]" : ""} mx-auto`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div
						className={`${isDesktop ? "w-[1200px]" : "px-[10px]"} mx-auto flex flex-col gap-5 pt-6 md:pt-8 pb-4`}
					>
						<SearchSection initQuery={queryParam} onSearch={onSearch} />
						<CatalogExpertiseFilterSection
							isDesktop={isDesktop}
							selectedExpertiseId={expertiseIdParam}
							onExpertiseClick={onExpertiseClick}
						/>
						<ClipSection
							isDesktop={isDesktop}
							query={queryParam}
							expertiseId={expertiseIdParam}
						/>
					</div>
				</div>
				<div className="py-5 md:py-6" aria-hidden />
				<div>
					<Footer isDesktop={isDesktop} activeButton={FooterButton.CLIPS} />
				</div>
			</div>
		</>
	);
}
